<div class="hub-layout-container" [ngClass]="{'banner-hidden': !showBanner}">

  <div class="hub-header-container">
    <app-header #header [showBanner]="showBanner"></app-header>
  </div>

  <div class="hub-sidebar-navs-container hub-custom-scrollbar" [ngClass]="{'is-sidebar-collapsed': !isSidebarExpanded }">
    @if (isLoggedIn()) {
      <app-sidebar-nav #sidebarNav>
      </app-sidebar-nav>
    }
  </div>

  <div class="hub-body-container">
    <router-outlet></router-outlet>
  </div>

  <div class="hub-footer-container">
    <app-footer></app-footer>
  </div>
</div>

<app-cookie-banner></app-cookie-banner>

<app-hub-toast></app-hub-toast>

<app-error-container></app-error-container>
